import Page from '../page';

export default class ResetPasswordIndex extends Page {
	constructor(...args) {
		super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {

        // Body <3
        this.dom.body = document.body;

        // Get container
        this.dom.container = this.dom.page.querySelector('.js-reset-container');

        // Get email input
        this.dom.email = this.dom.page.querySelector('.js-input-email');

        // Get error message
        this.dom.error = this.dom.page.querySelector('.js-error-message');

        // Get passwords input
        this.dom.password = this.dom.page.querySelector('.js-input-password');
        this.dom.password_confirmed = this.dom.page.querySelector('.js-input-password-confirmed');

        // Get login and rp_key
        this.dom.login = this.dom.page.querySelector('.js-input-login');
        this.dom.key = this.dom.page.querySelector('.js-input-key');

        // Get submit buttons
        this.dom.cta = this.dom.page.querySelector('.js-submit-reset');
        this.dom.ctaModify = this.dom.page.querySelector('.js-modify-password');

        this.cta  = ( this.dom.page.classList.contains('process-reset')) ? this.dom.ctaModify : this.dom.cta ;

        this._init();
    }

    _init() {

        // Init process
        this._is_process = false;

        // Bind submit buttons
        if (this.cta) {
            this.cta.addEventListener('click', () => {
                this._process();
            });
        }

        // this.dom.body.addEventListener( 'keypress', (e) => {
        //     if(e.keyCode == 13)
        //         this._process();
        // });
    }

    _process() {

        if( this._is_process == false ) {

            this._is_process = true;
            this.dom.error.classList.remove('error');

            // ASKING PASSWORD RESET (SEND EMAIL)
            if ( this.dom.page.classList.contains('request-reset') ) {

                this.dom.error.style.display = 'none';

                this._action = 'candiapro_send_reset_password';

                // Check email integrity
                if( this._checkEmail() ) {
                    this.dom.email.classList.remove('error');

                    var data = new FormData();
                    data.append( 'email', this.dom.email.value );

                    this._request( data );
                } else {
                    this.dom.email.classList.add('error');
                }
            }

            // CREATE NEW PASSWORD
            if ( this.dom.page.classList.contains('process-reset') ) {
                this._action = 'candiapro_reset_password';

                if( this._checkPasswords() ) {
                    this.dom.password.classList.remove('error');
                    this.dom.password.classList.add('success');
                    this.dom.password_confirmed.classList.remove('error');
                    this.dom.password_confirmed.classList.add('success');

                    var data = new FormData();
                    data.append( 'pass1', this.dom.password.value );
                    data.append( 'pass2', this.dom.password_confirmed.value );
                    data.append( 'rp_key', this.dom.key.value );
                    data.append( 'rp_login', this.dom.login.value );

                    this._request( data );

                } else {
                    this.dom.password.classList.add('error');
                    this.dom.password.classList.remove('success');
                    this.dom.password_confirmed.classList.add('error');
                    this.dom.password_confirmed.classList.remove('success');
                }
            }

            this._is_process = false;
        }

    }


    _checkEmail() {
        var regExp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return ( regExp.test( this.dom.email.value ) ) ? true : false;
    }

    _checkPasswords() {
        if( this.dom.password.value == this.dom.password_confirmed.value && this.dom.password.value.length > 4 ) {
            return true;
        }
        return false;
    }

    _request( data ) {
        this.dom.body.classList.add('loading');

        this.cta.classList.add('loading');

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/ajax.php?action=' + this._action, true);
        xhr.onreadystatechange = function () {
            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
                this._response( JSON.parse( xhr.response ) );
            }
            this._is_process = false;
            this.cta.classList.remove('loading');
            this.dom.body.classList.remove('loading');
        }.bind(this);
        xhr.send(data);
    }

    _response( response ) {

        if( response.success == true ) {
            this.dom.container.querySelector('.step-1').style.display = 'none';
            this.dom.container.querySelector('.step-2').style.display = 'block';
        } else {
            if( response.data.type == 'user_not_found' ) {
                this.dom.error.innerHTML = response.data.error_message;
                this.dom.error.classList.add('error');
            }
        }
    }

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/reset-password/reset-password-index.js